function playVideo(blockId) {
   const container = document.getElementById(blockId);
   if (!container) return;

   const video = container.querySelector('video');
   const buttonContainer = container.querySelector('.play-button-container');

   if (video) {
       video.controls = true;
       video.play().catch(err => console.error('Video konnte nicht abgespielt werden:', err));
   }

   if (buttonContainer) {
       buttonContainer.style.display = 'none';
   }
}

// Alle Play-Buttons automatisch binden
document.addEventListener('DOMContentLoaded', () => {
   document.querySelectorAll('.play-button').forEach(button => {
       button.addEventListener('click', () => {
           const blockId = button.getAttribute('data-block-id');
           if (blockId) {
               playVideo(blockId);
           }
       });
   });
});

export { playVideo };


let teaserId;
const teaserSliders = document.querySelectorAll('.text-media-slider');

const textMediaSliderInit = function() {
    teaserSliders.forEach((teaserEl) => {
        teaserId = teaserEl.getAttribute('data-slider-id');

        const nextBtn = document.querySelector(`.swiper-btn-next[data-slider-id="${teaserId}"]`);
        const prevBtn = document.querySelector(`.swiper-btn-prev[data-slider-id="${teaserId}"]`);


        let teaserSwiper = new Swiper(`#slider--${teaserId}`, {

            loop: true,
            slidesPerView: 1,
            spaceBetween: 40,

            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },

            speed: 1200,
            // autoplay: {
            //    delay: 6000,
            //    disableOnInteraction: false,
            // },
        });
    });
}

export { textMediaSliderInit }
